import { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";
import { Link } from "react-router-dom";
import { FaHashtag } from "react-icons/fa";

export default function PopularTagsSidebar({ onLinkClick, className = "" }) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(getApiUrl("/api/poems/tags/trending?limit=12&window=all"))
      .then((res) => res.json())
      .then((data) => setTags(Array.isArray(data) ? data : []))
      .catch(() => setTags([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={`app-sidebar-tags ${className}`.trim()}>
      <h2 className="app-sidebar-heading">
        <FaHashtag className="app-sidebar-heading-icon" aria-hidden="true" />
        Popular tags
      </h2>

      {loading ? (
        <div className="app-sidebar-tags__grid">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <span key={i} className="app-sidebar-tags__skeleton" />
          ))}
        </div>
      ) : tags.length === 0 ? (
        <p className="app-sidebar-tags__empty">No tags yet. Add tags when you publish poems.</p>
      ) : (
        <div className="app-sidebar-tags__grid">
          {tags.map(({ tag }) => (
            <Link
              key={tag}
              to={`/?q=${encodeURIComponent(tag)}`}
              className="app-sidebar-tags__chip"
              onClick={() => onLinkClick?.()}
            >
              #{tag}
            </Link>
          ))}
        </div>
      )}

      <Link
        to="/"
        className="app-sidebar-tags__explore"
        onClick={() => onLinkClick?.()}
      >
        Explore all tags
      </Link>
    </div>
  );
}
